module.exports = __webpack_public_path__ + "static/contribution-train-icon-70c154e09fd59e5d971495c3be78407e.svg";